module.exports = __webpack_public_path__ + "img/picto-facebook-rose.7f4f5c36.svg";